import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { UserProvider } from '../user.service';
import { AuthService } from '../auth.service';
import { NgForm } from '@angular/forms';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css']
})
export class DocumentosComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  
  divTabelaCompleta: boolean = true;
  divTabelaPastaSelecionada: boolean = false;
  divTabelaCompletaBoleto: boolean = true;
  divTabelaPastaSelecionadaBoleto: boolean = false;
  listaDocsPastaSelecionada = [];
  listaBoletoPastaSelecionada = [];
  listaDocUserComum = [];
  nomePastaSelecionada;
  nomePastaBoletoSelecionada;

  listaDoc = [];
  listaBoleto = [];
  listaPastas = [];
  listaPastasBoleto = [];
  nome: string;
  valorUsuario;

  //upload
  failMessage: boolean = false;
  file: File;
  color: string = 'primary';
  mode: 'determinate';
  progressBarValue;
  nomeDocumento;
  arquivo;
  referencia;
  uploadArquivo: String;

  constructor(    
    public authService: AuthService,
    public userservice: UserProvider,
    public zone: NgZone
  ) {

      this.referencia = firebase.storage().ref();
     }

  ngOnInit() {
    //documentos
    this.userservice.consultarDoc().then((res: any) => {
      this.listaDoc = res;
    });

    //boletos
    this.userservice.consultarBoleto().then((res: any) => {
      this.listaBoleto = res;
    });

    //documentos postados para o contador pelo usuário
    this.userservice.consultarDocUserComum().then((res: any) => {
      this.listaDocUserComum = res;
    });

    this.userservice.getuserdetails().then((result: any) => {
      this.nome = result.displayName;
      this.valorUsuario = result.uid;
    });

    //pastas de documentos
    this.userservice.consultaPastasUsuarioComum().then((res: any) => {
      this.listaPastas = res;
    })

    //pastas de boletos
    this.userservice.consultaPastasBoletoUsuarioComum().then((res: any) => {
      this.listaPastasBoleto = res;
    })
  }

  atualizaArquivo(event) {
    this.arquivo = event.target.files[0]; 
    this.uploadArquivo = "Novo Documento Selecionado";
    this.progressBarValue = 0;
  }

  enviarArquivo(arquivo) {
    if(this.arquivo == null){
      this.failMessage = true;
      setTimeout(() => this.failMessage = false, 5000);
    }else{
      let caminho = this.referencia.child(this.valorUsuario+'/'+'docsUsuario'+'/'+this.arquivo.name);
      const tarefa = caminho.put(this.arquivo);

      tarefa.on('state_changed', (snapshot)=>{
          this.progressBarValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          if(this.progressBarValue == 100){
            this.uploadArquivo = "Upload Realizado com sucesso";
          }
      }, error => {
         alert('Erro para transferir o arquivo!');
      }, () => {
        
         console.log(tarefa.snapshot.downloadURL);
         this.userservice.adicionarDocumentoUserComum(this.valorUsuario, this.nomeDocumento, tarefa.snapshot.downloadURL).then((res: any) => {
            this.form.reset();
            this.zone.run(() => {
              if(res.success){
                this.userservice.consultarDocUserComum().then((res: any) => {
                  this.listaDocUserComum = res;
                })
              }else{
                console.log('ERRO');
              }    
            }) 

        })
      });
    }
  }

  pastaSelecionada(idPastaSelecionada){
    this.userservice.consultaNomePastaUsuarioSelecionada(idPastaSelecionada).then((res: any) => {
      this.nomePastaSelecionada = res.nomePasta;
    })
    this.userservice.consultaDocsUsuarioPastaSelecionada(idPastaSelecionada).then((res: any) => {
      this.listaDocsPastaSelecionada = res;
      this.divTabelaCompleta = false;
      this.divTabelaPastaSelecionada = true;
    })    
  }

  pastaBoletoSelecionada(idPastaSelecionada){
    this.userservice.consultaNomePastaUsuarioBoletoSelecionada(idPastaSelecionada).then((res: any) => {
      this.nomePastaBoletoSelecionada = res.nomePasta;
    })
    this.userservice.consultaBoletosUsuarioPastaSelecionada(idPastaSelecionada).then((res: any) => {
      this.listaBoletoPastaSelecionada = res;
      this.divTabelaCompletaBoleto = false;
      this.divTabelaPastaSelecionadaBoleto = true;
    })    
  }

  voltarDocumentosRaiz(){
    this.divTabelaCompleta = true;
    this.divTabelaPastaSelecionada = false;
  }

  voltarBoletoRaiz(){
    this.divTabelaCompletaBoleto = true;
    this.divTabelaPastaSelecionadaBoleto = false;
  }

  signOut() {
    this.authService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/documentos/documentos.component.ts